export default __webpack_public_path__ + "static/media/image4.66d32b7e.jpg";